import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.875 8.407c-.2-.391-4.4-8.407-11.9-8.407S.275 8.016.075 8.407q-.15.44 0 .88c.2.293 4.4 8.31 11.9 8.31s11.7-8.017 11.9-8.408c.1-.195.1-.586 0-.782m-11.9 7.234c-5.4 0-8.9-5.279-9.9-6.843.9-1.564 4.5-6.843 9.9-6.843s8.9 5.279 9.9 6.843c-1 1.564-4.5 6.843-9.9 6.843m0-10.753c-2.2 0-4 1.76-4 3.91s1.8 3.91 4 3.91 4-1.76 4-3.91-1.8-3.91-4-3.91m0 5.865c-1.1 0-2-.88-2-1.955s.9-1.955 2-1.955 2 .88 2 1.955-.9 1.955-2 1.955"
    }, null, -1)
  ]))]))
}
export default { render: render }